/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiInCoordinates
 */
export interface PoiInCoordinates {
    /**
     * 
     * @type {number}
     * @memberof PoiInCoordinates
     */
    geoLatitude: number;
    /**
     * 
     * @type {number}
     * @memberof PoiInCoordinates
     */
    geoLongitude: number;
}

export function PoiInCoordinatesFromJSON(json: any): PoiInCoordinates {
    return PoiInCoordinatesFromJSONTyped(json, false);
}

export function PoiInCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiInCoordinates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'geoLatitude': json['geoLatitude'],
        'geoLongitude': json['geoLongitude'],
    };
}

export function PoiInCoordinatesToJSON(value?: PoiInCoordinates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'geoLatitude': value.geoLatitude,
        'geoLongitude': value.geoLongitude,
    };
}


